module.exports = __webpack_public_path__ + "media/images/sample/product-5-c378b9f3f6e59aa91b1ba14a4f109ee9.png";